import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { DesktopHome } from './pages/DesktopHome';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { AppShellLayout } from './components/AppShell/AppShellLayout';
import { BranchesPage } from './features/branches/BranchesPage';
import { DevicesPage } from './features/devices/DevicesPage';
import { UsersPage } from './features/users/UsersPage';
import { RolesPage } from './features/roles/RolesPage';
import { CategoriesPage } from './features/categories/CategoriesPage';
import { ItemsPage } from './features/items/ItemsPage';
import { IngredientsPage } from './features/ingredients/IngredientsPage';
import { AuditPage } from './features/audit/AuditPage';
import { TaxesPage } from './features/taxes/TaxesPage';
import { PaymentMethodsPage } from './features/payment-methods/PaymentMethodsPage';
import { ModifierGroupsPage } from './features/modifier-groups/ModifierGroupsPage';
import { ReportsPage } from './features/reports/ReportsPage';
import { LiveSalesPage } from './features/reports/LiveSalesPage';
import { AiAssistantPage } from './features/ai/AiAssistantPage';
import { InventoryPage } from './features/inventory/InventoryPage';
import { TransfersPage } from './features/inventory/TransfersPage';
import { ExpiringPage } from './features/inventory/ExpiringPage';
import { StockCountPage } from './features/inventory/StockCountPage';
import { ReorderPage } from './features/inventory/ReorderPage';
import { ValuationPage } from './features/inventory/ValuationPage';
import { SuppliersPage } from './features/purchasing/SuppliersPage';
import { PurchaseOrdersPage } from './features/purchasing/PurchaseOrdersPage';
import { StationsPage } from './features/kitchen-stations/StationsPage';
import { FloorPlanPage } from './features/floor-plan/FloorPlanPage';
import { LabelsPage } from './features/labels/LabelsPage';
import { PromotionsPage } from './features/promotions/PromotionsPage';
import { CustomersPage } from './features/customers/CustomersPage';
import { LoyaltyPage } from './features/loyalty/LoyaltyPage';
import { GiftCardsPage } from './features/loyalty/GiftCardsPage';
import { NotificationsPage } from './features/notifications/NotificationsPage';
import { CallCenterPage } from './features/call-center/CallCenterPage';
import { ChartOfAccountsPage } from './features/accounting/ChartOfAccountsPage';
import { JournalPage } from './features/accounting/JournalPage';
import { AccountingReportsPage } from './features/accounting/AccountingReportsPage';
import { SalesInvoicesPage } from './features/accounting/SalesInvoicesPage';
import { PurchaseInvoicesPage } from './features/accounting/PurchaseInvoicesPage';
import { ChequesPage } from './features/accounting/ChequesPage';
import { ExpensesPage } from './features/accounting/ExpensesPage';
import { EmployeesPage } from './features/hr/EmployeesPage';
import { PayrollPage } from './features/hr/PayrollPage';
import { AttendancePage } from './features/hr/AttendancePage';
import { LeavePage } from './features/hr/LeavePage';
import { RosterPage } from './features/hr/RosterPage';
import { ShiftTemplatesPage } from './features/hr/ShiftTemplatesPage';
import { AccountingDashboardPage } from './features/accounting/AccountingDashboardPage';
import { AccountingPeriodsPage } from './features/accounting/AccountingPeriodsPage';
import { PaymentTermsPage } from './features/accounting/PaymentTermsPage';
import { CostCentersPage } from './features/accounting/CostCentersPage';
import { BudgetsPage } from './features/accounting/BudgetsPage';
import { BankReconciliationPage } from './features/accounting/BankReconciliationPage';
import { FixedAssetsPage } from './features/accounting/FixedAssetsPage';
import { ProductionPage } from './features/inventory/ProductionPage';
import { SettingsPage } from './features/settings/SettingsPage';
import { DeliveryZonesPage } from './features/online/DeliveryZonesPage';
import { ProjectsPage } from './features/projects/ProjectsPage';
import { SupportPage } from './features/support/SupportPage';
import { QualityPage } from './features/quality/QualityPage';
import { SellingPage } from './features/selling/SellingPage';
import { CustomFieldsPage } from './features/custom-fields/CustomFieldsPage';
import { PlatformLayout, PlatformLoginPage } from './features/platform/PlatformLayout';
import { PlatformTenantsPage } from './features/platform/PlatformTenantsPage';
import { PlatformCrmPage } from './features/platform/PlatformCrmPage';
import { PlatformUsersPage } from './features/platform/PlatformUsersPage';
import { PlatformReportsPage } from './features/platform/PlatformReportsPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Wheels staff control panel — its own auth, outside the tenant shell. */}
      <Route path="/platform/login" element={<PlatformLoginPage />} />
      <Route path="/platform" element={<PlatformLayout />}>
        <Route index element={<PlatformTenantsPage />} />
        <Route path="crm" element={<PlatformCrmPage />} />
        <Route path="reports" element={<PlatformReportsPage />} />
        <Route path="users" element={<PlatformUsersPage />} />
      </Route>
      <Route
        element={
          <ProtectedRoute>
            <AppShellLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DesktopHome />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/items" element={<ItemsPage />} />
        <Route path="/ingredients" element={<IngredientsPage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/modifier-groups" element={<ModifierGroupsPage />} />
        <Route path="/taxes" element={<TaxesPage />} />
        <Route path="/payment-methods" element={<PaymentMethodsPage />} />
        <Route path="/branches" element={<BranchesPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/roles" element={<RolesPage />} />
        <Route path="/devices" element={<DevicesPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/live-sales" element={<LiveSalesPage />} />
        <Route path="/ai" element={<AiAssistantPage />} />
        <Route path="/production" element={<ProductionPage />} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/transfers" element={<TransfersPage />} />
        <Route path="/expiring" element={<ExpiringPage />} />
        <Route path="/stock-count" element={<StockCountPage />} />
        <Route path="/reorder" element={<ReorderPage />} />
        <Route path="/valuation" element={<ValuationPage />} />
        <Route path="/suppliers" element={<SuppliersPage />} />
        <Route path="/purchase-orders" element={<PurchaseOrdersPage />} />
        <Route path="/kitchen-stations" element={<StationsPage />} />
        <Route path="/floor-plan" element={<FloorPlanPage />} />
        <Route path="/labels" element={<LabelsPage />} />
        <Route path="/promotions" element={<PromotionsPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/loyalty" element={<LoyaltyPage />} />
        <Route path="/gift-cards" element={<GiftCardsPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/call-center" element={<CallCenterPage />} />
        <Route path="/accounting" element={<AccountingDashboardPage />} />
        <Route path="/accounting-periods" element={<AccountingPeriodsPage />} />
        <Route path="/payment-terms" element={<PaymentTermsPage />} />
        <Route path="/cost-centers" element={<CostCentersPage />} />
        <Route path="/budgets" element={<BudgetsPage />} />
        <Route path="/bank-reconciliation" element={<BankReconciliationPage />} />
        <Route path="/accounts" element={<ChartOfAccountsPage />} />
        <Route path="/journal" element={<JournalPage />} />
        <Route path="/accounting-reports" element={<AccountingReportsPage />} />
        <Route path="/sales-invoices" element={<SalesInvoicesPage />} />
        <Route path="/purchase-invoices" element={<PurchaseInvoicesPage />} />
        <Route path="/cheques" element={<ChequesPage />} />
        <Route path="/expenses" element={<ExpensesPage />} />
        <Route path="/fixed-assets" element={<FixedAssetsPage />} />
        <Route path="/employees" element={<EmployeesPage />} />
        <Route path="/attendance" element={<AttendancePage />} />
        <Route path="/roster" element={<RosterPage />} />
        <Route path="/shift-templates" element={<ShiftTemplatesPage />} />
        <Route path="/leave" element={<LeavePage />} />
        <Route path="/payroll" element={<PayrollPage />} />
        <Route path="/online" element={<DeliveryZonesPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/quality" element={<QualityPage />} />
        <Route path="/selling" element={<SellingPage />} />
        <Route path="/custom-fields" element={<CustomFieldsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
